import {ActionBrick, registerBrick, ErrorFlow} from 'olympe';
import {getLogger} from '@olympeio/core';
import {createErrorFlowMessage, isValidConfig, loadConfig, validateCells} from './dataFormatHandlers';

export default class ValidateExcelSheet extends ActionBrick {
    /**
     * @override
     */
    init($) {
        this.logger = getLogger('ValidateExcelSheet');
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Object} excelSheet
     * @param {Object} configType
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    update($, [excelSheet, configType], [forwardEvent, setErrorFlow]) {
        try {
            // Guards to validate inputs
            if (!excelSheet && typeof excelSheet !== 'object') {
                throw new Error(`Invalid excelSheet: "${excelSheet}"`);
            }

            if (!isValidConfig(configType)) {
                throw new Error('Invalid configuration type provided, should extend Validate Excel Config Data object');
            }
            const expectedCells = loadConfig(configType);
            const validationResults = validateCells(excelSheet, expectedCells);

            if (validationResults.isValid) {
                forwardEvent();
            } else {
                setErrorFlow(createErrorFlowMessage(validationResults, 0));
            }
        } catch (error) {
            this.logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error, 1));
        }
    }
}

registerBrick('018f52c5564718a5bb04', ValidateExcelSheet);
